module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ea52886228e4caad4743ea02af5104fc.gif";